// Where each AI provider keeps its instructions, and what the CLI ships for it.
//
// Every provider has its own rules — which file it reads as project instructions, whether it has a notion of
// subagents, and where those live. None of that is guessable from one provider's layout, so it is declared
// per provider here rather than inferred. Adding a provider is adding an entry plus its own `init-<provider>`
// command; nothing about one provider's layout leaks into another's.
//
// This is the *target project* side. The packed side — what the CLI ships under
// `ai-docs/providers/<id>/` — is the same `id` plus the two names below it.

/** The orchestrator segment, inside `ai-docs/providers/<id>/`. */
export const ORCHESTRATOR_SEGMENT_FILE = 'main-orchestrator-segment.md'

/** The agent definitions, inside `ai-docs/providers/<id>/`. */
export const PROVIDER_AGENTS_DIRECTORY = 'agents'

export interface ProviderLayout {
  /** Directory name under `ai-docs/providers/`, and the CLI's name for the provider. */
  id: string
  /** How the provider is named in output written for a human. */
  label: string
  /**
   * The provider's own project-instructions file, relative to the project root.
   *
   * The CLI never owns this file — it owns only the region between its markers inside it.
   */
  instructionsFile: string
  /**
   * Where the provider looks for subagent definitions, relative to the project root.
   *
   * These files *are* CLI-owned and are overwritten on every run.
   */
  agentsDirectory: string
}

/**
 * Claude Code.
 *
 * It reads `CLAUDE.md` and specifically **not** `AGENTS.md` — the cross-vendor convention is invisible to it,
 * which is the whole reason provider wiring cannot be one shared file written by `init`.
 */
export const CLAUDE_PROVIDER = 'claude'

export const PROVIDERS: Record<string, ProviderLayout> = {
  [CLAUDE_PROVIDER]: {
    id              : CLAUDE_PROVIDER,
    label           : 'Claude Code',
    instructionsFile: 'CLAUDE.md',
    agentsDirectory : '.claude/agents',
  },
}
